import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

const MarksEntryTab = ({
  exams,
  schedules,
  selectedExam,
  mySubjects,
  isAdmin,
  isTeacher,
  onSelectExam,
  onEnterMarks
}) => {
  const filteredSchedules = schedules.filter(s => {
    // Admin sees all, Teacher sees only their assigned subjects
    if (isAdmin) return true;
    if (isTeacher && mySubjects.length > 0) {
      return mySubjects.some(ms => 
        ms.subject_id === s.subject_id && ms.class_id === s.class_id
      );
    }
    return true;
  });

  return (
    <div className="space-y-4">
      <div className="flex justify-between items-center">
        <div>
          <h2 className="text-xl font-semibold">Marks Entry</h2>
          {isTeacher && mySubjects.length > 0 && (
            <p className="text-sm text-muted-foreground mt-1">
              You can enter marks for: {mySubjects.map(s => s.subject_name).join(', ')}
            </p>
          )}
        </div>
        <Select value={selectedExam?.id || ''} onValueChange={onSelectExam}>
          <SelectTrigger className="w-[200px]"><SelectValue placeholder="Select Exam" /></SelectTrigger>
          <SelectContent>
            {exams.map(e => <SelectItem key={e.id} value={e.id}>{e.name}</SelectItem>)}
          </SelectContent>
        </Select>
      </div>

      {selectedExam && schedules.length > 0 ? (
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
          {filteredSchedules.map(s => (
            <Card key={s.id} className="hover:shadow-md cursor-pointer" onClick={() => onEnterMarks(s.id)}>
              <CardHeader>
                <CardTitle className="text-base">{s.class_name} - {s.subject_name}</CardTitle>
                <CardDescription>{s.exam_date}</CardDescription>
              </CardHeader>
              <CardContent>
                <div className="flex justify-between text-sm">
                  <span>Max Marks: {s.max_marks}</span>
                  <Badge variant={s.marks_entered ? 'default' : 'secondary'}>
                    {s.marks_entered ? 'Marks Entered' : 'Pending'}
                  </Badge>
                </div>
              </CardContent>
            </Card>
          ))}
          {isTeacher && filteredSchedules.length === 0 && (
            <Card className="p-8 text-center text-muted-foreground col-span-full">
              No schedules found for your assigned subjects in this exam.
            </Card>
          )}
        </div>
      ) : (
        <Card className="p-8 text-center text-muted-foreground">
          Select an exam to enter marks for scheduled subjects.
        </Card>
      )}
    </div>
  );
};

export default MarksEntryTab;
